{
  "enum": {
    "ExcDtcDtccaV1CreditDebit": {
      "CREDIT": "Credit",
      "DEBIT": "Debit",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcDtccaV1EventCompletenessStatus": {
      "COMPLETE": "Complete",
      "INCOMPLETE": "Incomplete",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcDtccaV1EventConfirmationStatus": {
      "CONFIRMED": "Confirmed",
      "UNCONFIRMED": "Unconfirmed",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcDtccaV1EventType": {
      "BANKRUPTCY": "Bankruptcy",
      "BOND_DEFAULT": "Bond Default",
      "CALL_ON_INTERMEDIATE_SECURITIES": "Call on Intermediate Securities",
      "CAPITALISATION": "Capitalisation",
      "CAPITAL_DISTRIBUTION": "Capital Distribution",
      "CAPITAL_GAINS": "Capital Gains",
      "CASH_DISTRIBUTION_FROM_NON_ELIGIBLE_SECURITIES": "Cash Distribution From Non Eligible Securities",
      "CASH_DIVIDEND": "Cash Dividend",
      "CERTIFICATE_OF_DEPOSIT_EARLY_REDEMPTION": "Certificate of Deposit Early Redemption",
      "CHANGE": "Change",
      "CLASS_ACTION": "Class Action",
      "CONSENT": "Consent",
      "CONVERSION": "Conversion",
      "DETACHMENT": "Detachment",
      "DIVIDEND_OPTION": "Dividend Option",
      "DIVIDEND_REINVESTMENT": "Dividend Reinvestment",
      "DRAWING": "Drawing",
      "DUTCH_AUCTION": "Dutch Auction",
      "EXCHANGE": "Exchange",
      "FINAL_MATURITY": "Final Maturity",
      "FINAL_PAYDOWN": "Final Paydown",
      "FULL_CALL": "Full Call",
      "INFORMATION": "Information",
      "INTEREST_PAYMENT": "Interest Payment",
      "INTERMEDIATE_SECURITIES_DISTRIBUTION": "Intermediate Securities Distribution",
      "LIQUIDATION_DIVIDEND": "Liquidation Dividend",
      "MERGER": "Merger",
      "NON_OFFICIAL_OFFER": "Non Official Offer",
      "ODD_LOT_SALE_PURCHASE": "Odd Lot Sale Purchase",
      "OTHER": "Other",
      "PARTIAL_REDEMPTION": "Partial Redemption",
      "PAY_IN_KIND": "Pay in Kind",
      "PLACE_OF_INCORPORATION": "Place of Incorporation",
      "PREFUNDING": "Prefunding",
      "PUT_REDEMPTION": "Put Redemption",
      "REDEMPTION_OF_WARRANT": "Redemption of Warrant",
      "REPURCHASE_OFFER": "Repurchase Offer",
      "REVERSE_STOCK_SPLIT": "Reverse Stock Split",
      "SPINOFF": "Spinoff",
      "STOCK_DIVIDEND": "Stock Dividend",
      "STOCK_SPLIT": "Stock Split",
      "TAX_ON_NON_DISTRIBUTED_PROCEEDS": "Tax on Non Distributed Proceeds",
      "TAX_RECLAIM": "Tax Reclaim",
      "TENDER": "Tender",
      "TERMINATION": "Termination",
      "UNSPECIFIED": "Unspecified",
      "WARRANT_EXERCISE": "Warrant Exercise",
      "WORTHLESS": "Worthless"
    },
    "ExcDtcDtccaV1FractionDisposition": {
      "CASH_IN_LIEU": "Cash in Lieu",
      "ISSUE_FRACTION": "Issue Fraction",
      "ROUND_DOWN": "Round Down",
      "ROUND_TO_NEAREST": "Round to Nearest",
      "ROUND_UP": "Round up",
      "UNKNOWN": "Unknown",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcDtccaV1ProcessingType": {
      "DISTRIBUTION": "Distribution",
      "GENERAL": "General",
      "REORGANIZATION": "Reorganization",
      "UNSPECIFIED": "Unspecified"
    },
    "ExcDtcDtccaV1SecurityRateType": {
      "ADDITIONAL_QUANTITY": "Additional Quantity",
      "NEW_TO_OLD": "New to Old",
      "UNSPECIFIED": "Unspecified"
    }
  },
  "oneOf": {
    "ExcDtcDtccaV1RateOrUnknown": {
      "rate": "Rate",
      "unknown": "Unknown"
    }
  }
}